import React from 'react';
import './Footer.css';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
	const navigate = useNavigate();

	window.onload = function () {
		window.scrollTo(0, 0);
		if (document.body.offsetHeight + 100 < window.innerHeight) {
			document.getElementsByTagName('footer')[0].classList.add('footer-fixed');
		}
	};

	return (
		<footer className='bg-gradient-to-r from-[#022c56] via-[#034068] to-[#045580] text-white'>
			<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-2 lg:py-12'>
				<div className='grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 items-start'>
					{/* Company Info */}
					<div className='text-center lg:text-left'>
						<h3 className='text-2xl font-bold mb-2 lg:mb-4 text-yellow-400'>B-Reporter</h3>
						<p className='text-blue-200 mb-3 lg:mb-4 leading-relaxed'>
							Multimodal, Scene-aware , Location-aware, <br />
							Authentic reporting system
						</p>
						<div className='flex justify-center space-x-4'>
							<a
								href='https://play.google.com/store/apps/details?id=com.iitd.breporter3'
								target='_blank'
								rel='noopener noreferrer'
								className='w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-200'
							>
								<i className='fab fa-google-play text-lg'></i>
							</a>
							<a
								href='https://apps.apple.com/in/app/my-news-my-report/id6744141391'
								className='w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors duration-200'
							>
								<i className='bi bi-android2 text-lg'></i>
							</a>
						</div>
					</div>

					{/* Address */}
					<div className='text-center'>
						<h4 className='text-lg font-semibold mb-2 lg:mb-4 text-yellow-300'>Official Address</h4>
						<address className='text-blue-200 not-italic leading-relaxed'>
							H.IN.KH.NO 293 S/F
							<br />
							Near Kher Singh Estate
							<br />
							Western Marg, Saidulajab
							<br />
							New Delhi, Delhi 110030
							<br />
							India
						</address>
					</div>

					{/* Quick Links */}
					<div className='text-center lg:text-right'>
						<h4 className='text-lg font-semibold mb-2 lg:mb-4 text-yellow-300'>Quick Links</h4>
						<div className='flex flex-col items-center space-y-2'>
							<button
								onClick={() => navigate('/policy')}
								className='text-blue-200 hover:text-yellow-300 transition-colors duration-200 font-medium'
							>
								Privacy Policy
							</button>
							<button
								onClick={() => navigate('/deleteAccount')}
								className='text-blue-200 hover:text-yellow-300 transition-colors duration-200 font-medium'
							>
								Delete Account
							</button>
							<button
								onClick={() => navigate('/contact')}
								className='text-blue-200 hover:text-yellow-300 transition-colors duration-200 font-medium'
							>
								Contact Us
							</button>
						</div>
					</div>
				</div>

				{/* Divider */}
				<div className='border-t border-white/20 my-6 lg:my-8'></div>

				{/* Copyright */}
				<div className='text-center'>
					<p className='text-blue-200 text-sm'>© 2025 B-Reporter. All rights reserved.</p>
					<p className='text-blue-300 text-xs mt-1 lg:mt-2'>Building trust through authentic reporting</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
